import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../..';
import ManualPayments from '../../../components/ManualPayments';
import { getManualPaymentsStateByClaimId } from '../../../redux/manual-payments/manual-payments.selectors';
import { fetchClaimManualPaymentsThunk } from '../../../redux/manual-payments/manual-payments.thunk';
import { getPendingPaymentPlanOrder } from '../../../redux/payment-plan/payment-plan.selectors';
import { AppState } from '../../../redux/root.reducer';
import { getFullClaimById } from '../../../redux/selectors/claim.selectors';
import { getClaimPaymentOrderFilterOptions } from '../Payments/order-filter-options';

interface ClaimManualPaymentsProps {
  claimId: string;
}

const ClaimManualPayments: React.FC<ClaimManualPaymentsProps> = ({ claimId }) => {
  const dispatch = useAppDispatch();
  const manualPaymentsState = useSelector((state: AppState) => getManualPaymentsStateByClaimId(state, claimId));
  const claim = useSelector((state: AppState) => getFullClaimById(state, claimId));
  const activeOrder = useSelector(getPendingPaymentPlanOrder(claimId));
  const activeOrderId = activeOrder ? activeOrder.id : undefined;
  const orderFilterOptions = getClaimPaymentOrderFilterOptions(claim, activeOrderId);
  const hasFetched = manualPaymentsState ? manualPaymentsState.hasFetched : false;

  useEffect(() => {
    if (!hasFetched) {
      dispatch(fetchClaimManualPaymentsThunk({ claimId }));
    }
  }, [claimId, hasFetched, dispatch]);

  return (
    <ManualPayments
      payments={manualPaymentsState ? manualPaymentsState.payments : []}
      isLoading={manualPaymentsState ? manualPaymentsState.isLoading : false}
      error={manualPaymentsState ? manualPaymentsState.error : undefined}
      activeOrderId={activeOrderId}
      orderFilterOptions={orderFilterOptions}
    />
  );
};

export default ClaimManualPayments;
